// Generate a simple session ID for tracking purposes
export function generateSessionId(): string {
  const existingSessionId = sessionStorage.getItem('session_id');
  
  if (existingSessionId) {
    return existingSessionId;
  }
  
  const sessionId = `session_${Date.now()}_${Math.random().toString(36).substring(2)}`;
  sessionStorage.setItem('session_id', sessionId);
  
  return sessionId;
}

// Initialize session ID on app load
export function initializeSession(): void {
  if (!sessionStorage.getItem('session_id')) {
    generateSessionId();
  }
}